<template>
	<div class="house">
		<navBar>{{ title }}</navBar>
		<div class="content-box">
			<div class="houseitem df-a" v-for="i in 10" :key="i">
				<div class="leftBox">
					
				</div>
				<div class=" df-d df-sa" style="height: 100%;">
					<p class="font30">柔光伴睡小夜灯</p>
					<p class="font24 mCG">兑换时间：2024-09-08</p>
					<p class="font24 mCG">订单号：611212142566131</p>
				</div>
				<div class="bnt font24 mCc df-mc">
					已兑换
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'houseBox',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '学习报告',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			navList: [{ name: '创意礼品' }, { name: '图书礼品' }, { name: '生活日用' }]
		};
	},
	created() {},
	methods: {
		getNavClass() {
			this.$api
				.getNavClass({
					navid: this.currentId
				})
				.then((res) => {
					let resData = res.data?.data || [];
					this.allRequest = resData.length;

					for (let i = 0; i < resData.length; i++) {
						this.$api
							.getCourseTypeContall({
								coursetypeid: resData[i].id
							})
							.then((res) => {
								this.acount = ++this.acount;
								resData[i].children = res.data || [];
							});
					}

					this.dataList = resData;
				});
		},
		goPage(path) {
			this.$router.push({
				path: path,
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.house {
	height: calc(100% - 1.08rem);
	padding: 0.34rem 0.28rem 0.28rem 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		.houseitem{
			width: 100%;
			background: #FFFFFF;
			border-radius: 0.1rem;
			padding: 0.28rem;
			position: relative;
			margin-bottom: 0.28rem;
			.leftBox{
				width: 1.6rem;
				height: 1.6rem;
				background-color: #f5faff;
				margin-right: 0.3rem;
			}
			.bnt{
				width: 1.16rem;
				height: 0.45rem;
				background: #FFF9F6;
				border-radius: 0.04rem;
				position: absolute;
				right: 0.28rem;
				top: 50%;
				margin-top: -0.25rem;
			}
		}
	}
}
</style>
